// import bcrypt from 'bcryptjs';

export const hashMatched = (raw, hash) => {
  const decodedNumber = atob(hash);
  return raw === decodedNumber;
};
